import { refType } from 'types';

export const setRef = (ref: refType, value: any) => {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
};
